import {getRequest} from "@pg-mono/request";
import {apiV2Link} from "@pg-mono/rp-api-routes";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {IRcnAddressesResponse, IRcnAddressKey} from "../types/IRcnAddress";

const CATALOG_CACHE_MS = 5 * 60 * 1000;
let catalog: Promise<IRcnAddressesResponse> | null = null;
let expiresAt = 0;

export const fetchRcnAddress = async (meta: IRPRequestMeta, address: IRcnAddressKey) => {
    // Autocomplete omits coordinates; the catalog provides the representative point for region lookup.
    if (!catalog || Date.now() >= expiresAt) {
        expiresAt = Date.now() + CATALOG_CACHE_MS;
        catalog = getRequest(meta, apiV2Link.address.list()).then((response: IRcnAddressesResponse) => {
            if (!response || !Array.isArray(response.addresses)) {
                throw new Error("Unexpected RCN address catalog response");
            }
            return response;
        });
        const pending = catalog;
        void pending.catch(() => {
            if (catalog === pending) {
                catalog = null;
            }
        });
    }
    const response = await catalog;
    return response.addresses.find((item) => item.city === address.city && item.street === address.street && item.number === address.number) ?? null;
};
import {getRequest} from "@pg-mono/request";
import {apiV2Link} from "@pg-mono/rp-api-routes";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {IRcnAddressesResponse, IRcnAddressKey} from "../types/IRcnAddress";

const CATALOG_CACHE_MS = 5 * 60 * 1000;
let catalog: Promise<IRcnAddressesResponse> | null = null;
let expiresAt = 0;

export const fetchRcnAddress = async (meta: IRPRequestMeta, address: IRcnAddressKey) => {
    // Autocomplete omits coordinates; the catalog provides the representative point for region lookup.
    if (!catalog || Date.now() >= expiresAt) {
        expiresAt = Date.now() + CATALOG_CACHE_MS;
        catalog = getRequest(meta, apiV2Link.address.list()).then((response: IRcnAddressesResponse) => {
            if (!response || !Array.isArray(response.addresses)) {
                throw new Error("Unexpected RCN address catalog response");
            }
            return response;
        });
        const pending = catalog;
        void pending.catch(() => {
            if (catalog === pending) {
                catalog = null;
            }
        });
    }
    const response = await catalog;
    return response.addresses.find((item) => item.city === address.city && item.street === address.street && item.number === address.number) ?? null;
};
